export default function HomeServices() {
  return (
    <section className="mt-20 md:mt-40 flex justify-center flex-wrap md:flex-nowrap">
      <div className="md:my-8">
          <h2 className="text-center text-slate-700 mt-10 text-3xl md:text-4xl md:mt-20">
            Our Services
          </h2>
          <p className="md:text-sm text-justify py-10 mx-10 md:mx-32 leading-5 md:leading-8 text-xs tracking-widest">
            We provide complete range of LOCKOUT TAGOUT products that
            establishes the employer’s responsibility to protect employees from
            hazardous energy sources on machines and equipment during service
            and maintenance. Also providing a proper training to guide
            employees/Staff to ensure that they know, understand, and follow the
            applicable provisions of the hazardous energy control procedures.
            Loto Audit/Mapping with complete details of identification of
            Hazardous Energies, Re-De Energisation Process and Requirement of
            Proper &amp; Suitable LOTO Devices for Isolation.
          </p>
      </div>
      <div className="md:my-8">
        <h2 className="text-center text-bold text-slate-700 mt-10 text-3xl md:text-4xl md:mt-20">
          About Us
        </h2>
        <p className="md:text-sm text-justify py-10 mx-10 md:mx-32 leading-5 md:leading-8 text-xs tracking-widest">
          M.N.Safety Solutions a young dynamic customer/client centric An
          <em className="ml-1">ISO 14001:2015 (EMS)</em> &amp;
          <em className="ml-1">OSHA’S ISO 45001:2018 Certified</em> company
          Manufacturers &amp; OEM of Quality Lockout Tagout Products to meet
          OSHA’S 29 CFR 1910.147 &amp; 1910.269 and Suppliers/Traders of
          Personnel Protective Equipments offering at very competitive and
          affordable pricing to retail clients and Resellers across India,
          Lockout Tag-out Products Covering, Electrical, Mechanical, Pneumatic,
          Hydraulic etc to Control/Isolate Various Hazardous Energies in a
          Complex Manufacturing on a day to day basis.
        </p>
      </div>
    </section>
  );
}
